import { gql } from '@apollo/client';

export const ADD_OR_UPDATE_TEXT_RESOURCE = gql`
  mutation addOrUpdateTextResource($input: TextResourceInput) {
    addOrUpdateTextResource(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_TEXT_RESOURCE_MUTATION = gql`
  mutation deleteTextResource($input: DeleteTextResourceInput) {
    deleteTextResource(input: $input) {
      commandId
      correlationId
    }
  }
`;
